/**
 * A simple helper to standardize how we calculate percentages into ints.
 * - Rounds down to the nearest integer.
 * - Handles division by zero (as 100% unless zeroTotalIsZero is true)
 */
export function calculatePercentInt(
  numCompleted: number,
  numTotal: number,
  zeroTotalIsZero: boolean = false
) {
  if (numTotal === 0) {
    if (zeroTotalIsZero) return 0;
    return 100;
  }
  return Math.round((100 * numCompleted) / numTotal);
}
